import { Component, OnInit, forwardRef, ElementRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { Moment } from 'src/app/shared/utils';
import { MESES } from './shared/constant/monthpicker';
import { MonthpickerModel } from './shared/model';

@Component({
  selector: 'app-monthpicker',
  templateUrl: './monthpicker.component.html',
  styleUrls: ['./monthpicker.component.sass'],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => MonthpickerComponent), multi: true }],
})
export class MonthpickerComponent implements OnInit, ControlValueAccessor {
  public value: MonthpickerModel = this.getDefault;
  public valueModal: MonthpickerModel = this.getDefault;
  public opened = false;

  private onChangeCallback: (_: any) => void = () => { };
  private onTouchedCallback: () => void = () => { };

  constructor(
    private el: ElementRef
  ) { }

  public ngOnInit(): void {

    const body = document.querySelector('body');

    body.addEventListener('click', (event) => {
      if (!this.opened || !event.target) {
        return;
      }

      if (this.el.nativeElement !== event.target && !this.el.nativeElement.contains(event.target)) {
        this.close();
      }
    }, false);
  }

  public registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  public writeValue(value: MonthpickerModel): void {
    this.value = value || this.getDefault;
    this.onChangeCallback(this.value || this.getDefault);
  }

  private get getDefault(): MonthpickerModel {
    const dt = Moment();
    return { year: +dt.format('YYYY'), month: +dt.format('MM') };
  }

  public toggle(event): void {
    if (!this.opened) {
      this.valueModal.year = this.value.year;
      this.valueModal.month = this.value.month;
      this.opened = true;
    } else {
      this.close();
    }
  }

  public close() {
    this.opened = false;
  }

  public text(): string {
    return `${MESES[this.value.month]} / ${this.value.year}`;
  }

  public sumYear(event, value: number): void {
    this.valueModal.year += value;
  }

  public setMonth(event, value: number): void {
    this.valueModal.month = value;
    this.close();

    if (this.onChangeCallback) {
      this.value.year = this.valueModal.year;
      this.value.month = this.valueModal.month;
      this.onChangeCallback(this.value);
    }
  }
}
